// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const getBanner = () => localStorage.getItem('warningBanner');

const setBanner = (banner: string) => sessionStorage.setItem('warningBanner', banner);

const PROJECT_VIEW_MODE_KEY = 'projectViewMode';
const PROJECT_VIEW_MODES: ProjectViewMode[] = ['list', 'cards'];

// Everything this tab remembers goes at logout, so the next sign-in on it starts afresh.
const clearSessionStorage = () => {
  sessionStorage.removeItem('warningBanner');
  sessionStorage.removeItem(PROJECT_VIEW_MODE_KEY);
};

// The projects list/tile choice, kept for the tab so a reload comes back to it (AUT-6509).
// Storage that refuses (a private window) or holds something unexpected reads as no remembered
// choice, and the store's default stands.
const getProjectViewMode = (): ProjectViewMode | null => {
  try {
    const stored = sessionStorage.getItem(PROJECT_VIEW_MODE_KEY);
    return PROJECT_VIEW_MODES.find((mode) => mode === stored) ?? null;
  } catch (error) {
    return null;
  }
};

const setProjectViewMode = (mode: ProjectViewMode) => {
  try {
    sessionStorage.setItem(PROJECT_VIEW_MODE_KEY, mode);
  } catch (error) {
    // A tab whose storage refuses keeps the choice in the store for as long as it stays open.
    console.warn('The projects view choice could not be remembered for this tab', error);
  }
};

export {
  getBanner,
  setBanner,
  clearSessionStorage,
  getProjectViewMode,
  setProjectViewMode,
};
